import React, { useEffect, useRef, useState } from "react";
import RoundCheckIcon from "../../images/svg/RoundCheckIcon.svg";
import { Info, Search, X } from "lucide-react";
import { Calendar } from "lucide-react";
import DateRangePickerCom from "./DateRangePicker";
import Selectbox from "../../components/Common/Selectbox";
import { APIUtility, IP_Address } from "../../Api";
import Loader from "../../components/Common/Loader";
import NoData from "../../components/Common/NoData";
import NoVehicleData from "../../components/Common/NoVehicleData";
import MaingateModal from "../../Modal/MaingateModal";
import QrCodeDetailsModal from "../../Modal/QrCodeDetailsModal";
import ViewImageModal from "../../Modal/ViewImageModal";
import { setVehicleEntriesData } from "../../Redux/CommonSlice/allDataSlice";
import { useDispatch, useSelector } from "react-redux";
import { addDays, format, startOfMonth, endOfMonth, subDays } from "date-fns";
import Pagination from "../../components/Common/Pagination";

const VehicleEntries = ({ showBoombarrierModal }) => {
  const imgRef = useRef(null);
  const [selectedButton, setSelectedButton] = useState("All");
  const [showDateRange, setShowDateRange] = useState(false);
  const [showMaigateModal, setShowMainGateModal] = useState(false);
  const [vehicleEntries, setVehicleEntries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [QrCodeDetailsModalShow, setQrCodeDetailsModalShow] = useState(false);
  const [ViewImageModalShow, setViewImageModalShow] = useState(false);
  const [qrcodeDetailsId, setQrCodeDetailsId] = useState(null);
  const [filterSelect, setFilterSelected] = useState({ search_string: "", validated_status: "", date_range_after: "", date_range_before: "", user_id: 1, });
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState({});
  const [isLiveStreamStart, setIsLiveStreamStart] = useState(false);
  const [socket, setSocket] = useState(null);
  const [socketOpen, setSocketOpen] = useState(false);
  const activeTabLabel = useSelector((state) => state.data.activeTabLabel);
  const auth = useSelector((state) => state.auth);
  const { user, camera_details } = auth;
  const [cameraFrame, setCameraFrame] = useState(null);
  const [noCameraFound, setNoCameraFound] = useState(false)

  const { permissions } = user?.user_permissions || {}

  const [state, setState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const dispatch = useDispatch();

  const optionData = [
    {
      label: "All",
      value: "All",
    },
    {
      label: "Verified",
      value: "validated",
    },
  ];

  const setDateFieldsCurrent = () => {
    setState([
      {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      },
    ]);
  };

  const GetVehicleData = async (currentIndex) => {

    setIsLoading(true);

    try {
      // const pageNo=filterSelect.search_string==""&&
      // filterSelect.validated_status==""&&
      // filterSelect.date_range_after==""&&
      // filterSelect.date_range_before==""

      const data = {
        ...filterSelect,
        page: currentIndex ? currentIndex : currentPage,
      };

      const res = await APIUtility.getVehicleEntriesData(data);

      if (res.status == 200) {
        setVehicleEntries(res.data?.serialized_data);
        setPaginationData(res.data?.pagination_details);
        dispatch(setVehicleEntriesData(res.data?.serialized_data));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error, "error");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let startDate = "";
    let endDate = "";

    const currentDate = new Date();
    if (selectedButton == "Daily") {
      startDate = currentDate;
      endDate = currentDate;
      setDateFieldsCurrent();
    } else if (selectedButton == "Weekly") {
      startDate = subDays(currentDate, 7);
      endDate = currentDate;
      setDateFieldsCurrent();
    } else if (selectedButton == "Monthly") {
      startDate = startOfMonth(currentDate);
      endDate = endOfMonth(currentDate);
      setDateFieldsCurrent();
    } else if (selectedButton == "custom") {
      startDate = "";
      endDate = "";
    } else if (selectedButton == "All") {
      startDate = "";
      endDate = "";
    }

    setFilterSelected((prev) => ({
      ...prev,
      date_range_after: startDate != "" ? format(startDate, "yyyy-MM-dd") : "",
    }));
    setFilterSelected((prev) => ({
      ...prev,
      date_range_before: endDate != "" ? format(endDate, "yyyy-MM-dd") : "",
    }));
  }, [selectedButton]);

  useEffect(() => {
    if (!showDateRange) {
      // setSelectedButton("");
    }
  }, [showDateRange]);

  useEffect(() => {
    if (!showBoombarrierModal || !showMaigateModal) {
      GetVehicleData();
    }
  }, [showBoombarrierModal, showMaigateModal]);


  const getButtonStyle = (buttonType) => {
    switch (buttonType) {
      case "validated":
        return {
          color: "#4DB748", // Green text color
          backgroundColor: "#4DB7480D", // Green
        };
      case "revalidate":
        return {
          backgroundColor: "#FF7171", // Red
          color: "#FFFFFF", // White text color
        };
      case "not_validated":
        return {
          backgroundColor: "#FEC601", // Yellow
          color: "#000000", // Black text color
        };
      case "Validate(disabled)":
        return {
          backgroundColor: "#FEC60166", // Light Yellow
          color: "#00000066", // Black text color
        };
      default:
        return {};
    }
  };

  const getButtonText = (buttonType) => {
    if (buttonType === "not_validated") {
      return "Validate";
    }
    return buttonType;
  };

  const TableColumn = [
    {
      name: "QR Code",
      className: "",
    },
    {
      name: "Vehicle No.",
      className: "w-[170px]",
    },
    {
      name: "Date and Time",
      className: "",
    },
    {
      name: "Reporting No.",
      className: "",
    },
    {
      name: "Gate Entry No.",
      className: "",
    },
    {
      name: "Vehicle Image",
      className: "",
    },
    {
      name: "Action",
      className: "w-[170px]",
    },
  ];

  useEffect(() => {
    GetVehicleData(1);
    setCurrentPage(1);
  }, [filterSelect]);

  useEffect(() => {
    let ws;

    const connectWebSocket = () => {
      ws = new WebSocket(`ws://${IP_Address}/ws/streams/`);

      ws.binaryType = "arraybuffer";

      ws.onopen = () => {
        console.log("WebSocket connection opened");
        setSocket(ws);
        ws.send(
          JSON.stringify({
            token: `${localStorage.getItem("accessToken")}`,
            camera_type: "main_gate",
          })
        );
      };

      ws.onmessage = (e) => {

        if (typeof e.data === "string") {
          const message = JSON.parse(e.data);

          if (message["loading"]) {
            setNoCameraFound(false)
            console.log("loading...");
          } else if (!message['camera_status']) {
            console.log("No Camera Found")
            setNoCameraFound(true)
          } else {
            setNoCameraFound(false)
            console.log("done...");
          }
        }

        if (e.data instanceof ArrayBuffer) {
          const frameData = e.data;
          setCameraFrame(frameData);
          setNoCameraFound(false)
          const img = document.getElementById("liveViewId");
          // if (img) {
          //   img.src = URL.createObjectURL(
          //     new Blob([frameData], { type: "image/jpeg" })
          //   );
          setIsLiveStreamStart(true);
          // }
        } else {
          console.warn("Unknown message type received:", e.data);
        }
      };

      ws.onclose = (e) => {
        console.error("Socket closed unexpectedly:", e);
        setIsLiveStreamStart(false);
        //     setTimeout(() => {

        // if (socketOpen &&  showBoombarrierModal) {
        //         console.log("Attempting to reconnect...");
        //         // connectWebSocket();
        //       }
        //     }, 1000);
      };

      ws.onerror = (e) => {
        console.error("Socket encountered error:", e);
        ws.close();
      };
    };
    if (socketOpen) {
      connectWebSocket();
    }

    return () => {
      if (ws) {
        ws.close();
      }
    };
  }, [socketOpen]);

  useEffect(() => {
    setSocketOpen(showMaigateModal);
  }, [showMaigateModal]);

  return (
    <div className="bg-[#F9F9F7] w-full h-full rounded-[6px] p-[13px] gap-[10px] ">
      {/* Header section */}
      <div className="w-full h-[45px] flex justify-between">
        {/* Date header */}
        <div className="font-[600] text-[#00000080] text-[18px] flex items-center text-lg font-['Roboto']">
          {selectedButton == "Daily"
            ? `  Today's Arrival - ${filterSelect.date_range_before}`
            : selectedButton == "All"
              ? "All - Arrivals"
              : `Arrival -  ${filterSelect.date_range_after} to ${filterSelect.date_range_before} `}
        </div>
        {/* Filter and search */}
        <div className="w-auto h-auto flex gap-[15px]">
          {/* Filter buttons */}
          <div className="rounded-[5px] p-[5px] flex justify-between items-center h-[45px]  bg-[#FFFFFF]">
            <button
              className={`w-auto h-full text-base font-['Roboto'] rounded-[3px] pt-[10px] pr-[20px] pb-[10px] pl-[20px] flex items-center font-semibold ${selectedButton === "All" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => setSelectedButton("All")}
            >
              All
            </button>
            <button
              className={`w-auto h-full text-base font-['Roboto'] rounded-[3px] pt-[10px] pr-[20px] pb-[10px] pl-[20px] flex items-center font-semibold ${selectedButton === "Daily" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => setSelectedButton("Daily")}
            >
              Daily
            </button>
            <button
              className={`w-auto h-full text-base font-['Roboto'] rounded-[3px] pt-[10px] pr-[20px] pb-[10px] pl-[20px] flex items-center font-semibold ${selectedButton === "Weekly" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => setSelectedButton("Weekly")}
            >
              Weekly
            </button>
            <button
              className={`w-auto h-full text-base font-['Roboto'] rounded-[3px] pt-[10px] pr-[20px] pb-[10px] pl-[20px] flex items-center font-semibold ${selectedButton === "Monthly" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => setSelectedButton("Monthly")}
            >
              Monthly
            </button>

            <button
              className={`w-auto h-full text-base font-['Roboto'] rounded-[3px] pt-[10px] pr-[20px] pb-[10px] pl-[20px] flex items-center font-semibold ${selectedButton === "custom" ? "bg-[#DEFEDC]" : ""
                }`}
              onClick={() => {
                setShowDateRange(true);
                setSelectedButton("custom");
              }}
            >
              <label className={`pr-1 cursor-pointer `} htmlFor="">
                <Calendar />
              </label>
            </button>
          </div>

          {/* Search input and filter dropdown */}

          <div className="flex items-center gap-[10px] rounded-[5px] pt-[5px] pr-[13px] pb-[5px] pl-[13px] w-[415px] h-[45px] border-[1px] border-[#00000033]  bg-[#FFFFFF66] text-[#00000066]">
            <Search />
            <input
              className="outline-none bg-transparent w-full text-[#979796] text-base font-medium font-['Roboto']"
              placeholder="Search Vehicle No., Reporting No. here"
              type="text"
              value={filterSelect.search_string}
              onChange={(e) =>
                setFilterSelected((prev) => ({
                  ...prev,
                  search_string: e.target.value,
                }))
              }
            />
          </div>

          {/* Filter dropdown */}

          <div className="w-[20vh] h-[45px] text-base font-medium font-['Roboto'] rounded-[5px] bg-[#FFFFFF] flex items-center">
            <Selectbox
              data={optionData}
              placeholder="Select Value"
              optionClass={" border-b"}
              containerClass={"w-[300px]"}
              onSelect={(value) => {
                setFilterSelected((prev) => ({
                  ...prev,
                  validated_status:
                    value[0].value == "All" ? "" : value[0].value,
                }));
              }}
              defaultValue={[{ label: "All", value: "All" }]}
            />
          </div>
        </div>
      </div>

      {/* Table section */}

      <div className="mt-[20px] h-hometable_h overflow-y-scroll hideScrollBar border-b-[1px] border-[#999999]">
        <table className="w-full overflow-y-scroll">
          {/* Table headers */}

          <thead className="w-full h-[46px] bg-white z-10">
            <tr>
              {TableColumn.map((item, i) => {
                return (
                  <th
                    key={i}
                    className={`h-full bg-[#FFFFFF] sticky top-0 border-r-[0.5px] last:border-0 border-[#0000001A]  text-[#00000099] font-[400] font-['Roboto'] text-center ${item.className}`}
                  >
                    <div className="flex justify-center items-center gap-[10px] border-b-[2px] border-[#00000066] p-[10px] whitespace-nowrap !z-[-1]">
                      {i == 0 ? (
                        <>
                          {item.name}
                          <div className="relative group">
                            <Info className="w-[19px]" />
                            <div className="absolute w-[130px] hidden group-hover:block top-[45px] left-[10%] rounded-[5px] transform translate-y-[-90%] translate-x-[-80%] bg-white shadow-md p-[10px] z-[100] mx-2 mt-9">
                              <ul className="list-none p-0 m-0 w-[200px] z-[1000]">
                                <li className="flex text-[14px] font-medium text-black items-center gap-1">
                                  <div className="h-3 w-3 rounded-full bg-[#DAB01B] mr-1"></div>
                                  {/* Yellow circle */}
                                  <span>M-Manually</span>
                                </li>
                                <li className="flex text-[14px] font-medium text-black items-center mt-[4.5px] gap-1">
                                  <div className="h-3 w-3 rounded-full bg-[#6CD04E] mr-1"></div>
                                  {/* Green circle */}
                                  <span>A-Automated</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </>
                      ) : (
                        item.name
                      )}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>

          {/* Table body */}
          <tbody className="w-full overflow-y-auto">
            {isLoading ? (
              <tr>
                <td className="h-[400px] w-full" colSpan={7}>
                  <div className="w-full h-full flex items-center justify-center">
                    <Loader />
                  </div>
                </td>
              </tr>
            ) : !vehicleEntries || vehicleEntries.length === 0 ? (
              <tr>
                <td className="h-[400px] w-full" colSpan={7}>
                  <NoVehicleData text={"No Vehicle Entries Added"} />
                </td>
              </tr>
            ) : (
              vehicleEntries.map((item) => (
                <tr
                  className="border-b-[1px] border-[#0000001A] w-full h-[51.2px]"
                  key={item.id}
                >
                  {/* QR Code */}
                  <td
                    className={`  text-base font-['Roboto'] cursor-pointer underline border-r-[0.5px] border-[#0000001A] p-[10px] text-center font-[500] ${item.entryType === "Automated"
                        ? "text-[#6CD04E] hover:bg-[#6CD04E1A]"
                        : "text-[#DAB01B] hover:bg-[#FFF9E399]"
                      }`}
                    onClick={() => {
                      setQrCodeDetailsId(item.user_vehicle_mapping_id);
                      setQrCodeDetailsModalShow(true);
                    }}
                  >
                    {item.qr_code || "-"}
                  </td>
                  {/* Vehicle No. */}
                  <td className="  text-base font-['Roboto'] border-r-[0.5px] border-[#0000001A] p-[10px] text-center font-[500]">
                    {item.vehicle_no || "-"}
                  </td>
                  {/* Date and Time */}
                  <td className="  text-base font-['Roboto'] border-r-[0.5px] border-[#0000001A] px-[15px] text-center font-[500] ">
                    <div className="flex justify-between">
                      <p className="m-0 flex items-center justify-between w-full px-[4%] gap-2">
                        <span>{item.date || "-"}</span>

                        <span>{item.time || ""}</span>
                      </p>
                    </div>
                  </td>
                  {/* Reporting No. */}
                  <td className="  text-base font-['Roboto'] border-r-[0.5px] border-[#0000001A] p-[10px] text-center font-[500]">
                    {item.reporting_number || (
                      <span className=" text-[13px] text-gray-400">
                        Vehicle Not Arrived Yet
                      </span>
                    )}
                  </td>
                  {/* Gate Entry No. */}
                  <td className="  text-base font-['Roboto'] border-r-[0.5px] border-[#0000001A] p-[10px] text-center font-[500]">
                    {item.gate_entry_number || (
                      <span className=" text-[13px] text-gray-400">
                        Vehicle Not Arrived Yet
                      </span>
                    )}
                  </td>
                  {/* Vehicle Image */}
                  <td className="text-base font-['Roboto'] border-r-[0.5px] border-[#0000001A] p-[10px] text-center font-[500]">
                    {item.action.btn_name === "validated" && item.vehicle_image_main_gate ? (
                      <p 
                        className="text-[#0073C7] m-0 cursor-pointer underline"
                        onClick={() => {
                          setQrCodeDetailsId(item.user_vehicle_mapping_id);
                          setViewImageModalShow(true);
                        }}
                      >
                        View Image
                      </p>
                    ) : (
                      <span className="text-[13px] text-gray-400 select-none">
                        Vehicle Not Arrived Yet
                      </span>
                    )}
                  </td>

                  {/* Action */}
                  <td className="  text-base font-['Roboto'] p-[10px] text-center font-[500] flex justify-center items-center">
                    {
                      permissions?.main_gate_validate_button ? <button
                        className={`text-base font-['Roboto'] font-bold py-[9px] px-[15px] rounded flex items-center justify-center capitalize ${item.action.btn_name !== "validated" ? ' pointer-events-auto' : 'pointer-events-none'}`}
                        style={getButtonStyle(item.action.btn_name)}
                        onClick={() => {
                          if (item.action.btn_name !== "validated") {
                            setQrCodeDetailsId(item.user_vehicle_mapping_id);
                            setShowMainGateModal(true);
                          }
                        }}
                      >
                        {item.action.btn_name === "validated" && (
                          <>
                            <img
                              src={RoundCheckIcon}
                              alt="Round Check Icon"
                              className="mr-2"
                            />
                          </>
                        )}
                        {getButtonText(item.action.btn_name)}
                      </button> : '-'
                    }

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <MaingateModal
          show={showMaigateModal}
          onHide={() => setShowMainGateModal(false)}
          qrcodeId={qrcodeDetailsId}
          socket={socket}
          imgRef={imgRef}
          setSocketOpen={setSocketOpen}
          socketOpen={socketOpen}
          isLiveStreamStart={isLiveStreamStart}
          cameraFrame={cameraFrame}
          noCameraFound={noCameraFound}
        />
      </div>

      {/* Pagination */}

      <div className="pt-[5px] flex justify-center">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={paginationData?.count || 10}
          pageSize={10}
          onPageChange={(page) => {
            setCurrentPage(page);
            GetVehicleData(page);
          }}
        />
      </div>

      <div className="">
        <DateRangePickerCom
          setShowDateRange={setShowDateRange}
          showDateRange={showDateRange}
          setFilterSelected={setFilterSelected}
          state={state}
          setState={setState}
          setSelectedButton={setSelectedButton}
        />
      </div>

      <QrCodeDetailsModal
        show={QrCodeDetailsModalShow}
        onHide={() => setQrCodeDetailsModalShow(false)}
        qrcodeId={qrcodeDetailsId}
      />

      <ViewImageModal
        show={ViewImageModalShow}
        onHide={() => setViewImageModalShow(false)}
        qrcodeId={qrcodeDetailsId}
      />
    </div>
  );
};

export default VehicleEntries;
